export default __webpack_public_path__ + "static/img4@2x-697cdd214eb48f60b318199cb5484683.jpg";